/* @ngInject */ export function RunBankStatement(BooksData, Tools) {
  /*****************************************************************************
   * Constructor */
  /**
   * @param  src    Source statement object.
   * @param  items  List of all items written against the account for this
   *                statement. This list will include cleared and uncleared
   *                items, with a flag to indicate whether it was cleared on this
   *                statement.
   *****************************************************************************/
  BooksData.BankStatement = function (src, items) {
    var bankStatement = Object.assign(
      Object.create(BooksData.BankStatement.prototype),
      src || {}
    );

    defineProperties(bankStatement);

    if (items) bankStatement.setItems(items);

    return bankStatement;
  };

  /*****************************************************************************
   * Prototype
   *****************************************************************************/
  BooksData.BankStatement.prototype = {
    credits: [],
    debits: [],
    serviceFee: {},
    interest: {},

    /** Filter items into separate lists. */
    setItems: function (items) {
      this.credits = items.filter(function (item) {
        return !item.isDebit;
      });
      this.debits = items.filter(function (item) {
        return item.isDebit;
      });
    }
  };

  /*****************************************************************************
   * defineProperties */
  /**
   * Creates accessors on the bankStatement passed in.
   *****************************************************************************/
  function defineProperties(bankStatement) {
    Object.defineProperties(bankStatement, {
      /*************************************************************************
       * clearedDebits */
      /**
       * Get the cleared debits by reducing the list of debits down to their
       * amount if cleared, or zero. Then add the interest if this statement has
       * not been reconciled (reconciled statements will already include the
       * interest as a debit item).
       *************************************************************************/
      clearedDebits: {
        get: function () {
          var cleared = this.debits.reduce(function (total, debit) {
            return total + (debit.cleared ? debit.amount : 0);
          }, 0);
          var interest = this.interest ? this.interest.amount || 0 : 0;
          return cleared + (!this.reconciled ? interest : 0);
        }
      },

      /*************************************************************************
       * clearedCredits */
      /**
       * Get the cleared credits by reducing the list of credits down to their
       * amount if cleared, or zero. Then subtract the service fee if this
       * statement has not been reconciled (reconciled statements will already
       * include the service fee as a credit item).
       *************************************************************************/
      clearedCredits: {
        get: function () {
          var cleared = this.credits.reduce(function (total, credit) {
            return total - (credit.cleared ? credit.amount : 0);
          }, 0);
          var serviceFee = this.serviceFee ? this.serviceFee.amount || 0 : 0;
          return cleared - (!this.reconciled ? serviceFee : 0);
        }
      },

      /*************************************************************************
       * unclearedDebits */
      /**
       * Get the uncleared debits by reducing the list of debits down to their
       * amount if cleared, or zero.
       *************************************************************************/
      unclearedDebits: {
        get: function () {
          return this.debits.reduce(function (total, debit) {
            return total + (debit.cleared ? 0 : debit.amount);
          }, 0);
        }
      },

      /*************************************************************************
       * unclearedCredits */
      /**
       * Get the uncleared credits by reducing the list of credits down to their
       * amount if cleared, or zero.
       *************************************************************************/
      unclearedCredits: {
        get: function () {
          return this.credits.reduce(function (total, credit) {
            return total - (credit.cleared ? 0 : credit.amount);
          }, 0);
        }
      },

      clearedTotal: {
        get: function () {
          return (this.clearedDebits || 0) + (this.clearedCredits || 0);
        }
      },
      unclearedTotal: {
        get: function () {
          return (this.unclearedDebits || 0) + (this.unclearedCredits || 0);
        }
      },
      clearedBalance: {
        get: function () {
          return (this.begBalance || 0) + (this.clearedTotal || 0);
        }
      },
      registerBalance: {
        get: function () {
          return (this.endBalance || 0) + (this.unclearedTotal || 0);
        }
      },
      balanced: {
        get: function () {
          return (
            Tools.roundMoney(this.clearedBalance) == (this.endBalance || 0)
          );
        }
      }
    });
  }
}
